module.exports = __webpack_public_path__ + "static/media/BjajF.d106e7b0.png";